import React, { useState, useEffect, useRef } from 'react';
import '../styles/Gallery-acordion.css';//import './Gallery.css';

import img1 from '../assets/galeria3.jpeg'; // Ajusta la ruta real
import img2 from '../assets/galeria5.jpg'; // Ajusta la ruta real
import img3 from '../assets/galeria4.jpg'; // Ajusta la ruta real
import img4 from '../assets/galeria1.jpeg'; // Ajusta la ruta real
import img5 from '../assets/galeria2.jpeg'; // Ajusta la ruta real

const eventTypes = ['Bodas', 'Cumpleaños', 'Eventos Corporativos'];

// Fotos con título y descripción
const photos = [
  { src: img1, alt: 'Evento 1' },
  { src: img2, alt: 'Evento 2' },
  { src: img3, alt: 'Evento 3' },
  { src: img4, alt: 'Evento 4' },
  { src: img5, alt: 'Evento 5' },
];

export default function Gallery() {
  return (
    <section id='gallery-accordion' className="accordion-section">
      <h2 className="accordion-title">Galería Interactiva</h2>
      <div className="accordion-container">
        {photos.map((photo, idx) => (
          <div key={idx} className="accordion-item">
            <img src={photo.src} alt={photo.alt} />
          </div>
        ))}
      </div>
    </section>
  );
}
